import { PageName } from '@anm/data/video-templates/pages';

type CategoryItemProps = {
  name: string;
  page: PageName;
};

export type CategoryTreeItem = CategoryItemProps & {
  children: CategoryItemProps[];
};

const categoriesTree = [
  {
    page: 'image',
    name: 'image',
    children: [
      { page: 'image-thumbnail', name: 'thumbnails' },
      { page: 'image-lower-third', name: 'lower third' },
      { page: 'image-meme', name: 'meme' },
      { page: 'image-facebook-cover', name: 'facebook cover' },
      { page: 'image-quote', name: 'quote' },
      { page: 'image-overlay', name: 'overlay' }
    ]
  },
  {
    page: 'live-streaming',
    name: 'live streaming',
    children: [
      { page: 'live-streaming-intro', name: 'intro' },
      { page: 'live-streaming-ended-screen', name: '‘Stream Ended’ Screen' },
      { page: 'live-streaming-us-theme', name: 'US theme' },
      { page: 'live-streaming-countdown', name: 'countdown' },
      { page: 'live-streaming-thumbnails', name: 'thumbnails' },
      { page: 'live-streaming-promo', name: 'promo templates' },
      { page: 'live-streaming-yogurt-theme', name: 'yogurt theme' },
      { page: 'live-streaming-coffee-theme', name: 'coffee theme' },
      { page: 'live-streaming-nature-theme', name: 'nature theme' },
      { page: 'live-streaming-brb-screens', name: 'be right back' },
      { page: 'live-streaming-emerald-theme', name: 'emerald theme' },
      { page: 'live-streaming-subtle-bw-theme', name: 'subtle theme' },
      { page: 'live-streaming-spiritual-theme', name: 'spiritual theme' },
      { page: 'live-streaming-honeycomb-theme', name: 'honeycomb theme' },
      { page: 'live-streaming-geometric-theme', name: 'geometric theme' },
      { page: 'live-streaming-wave-video-theme', name: 'Company theme' },
      { page: 'live-streaming-smd-summit-theme', name: 'SMD summit theme' },
      { page: 'live-streaming-black-star-theme', name: 'black star theme' },
      { page: 'live-streaming-dark-peach-theme', name: 'dark peach theme' },
      { page: 'live-streaming-color-bars-theme', name: 'color bars theme' },
      { page: 'live-streaming-neon-smoke-theme', name: 'neon-smoke theme' },
      { page: 'live-streaming-acid-pastel-theme', name: 'acid pastel theme' },
      {
        page: 'live-streaming-trn-lower-third',
        name: 'transparent lower third templates'
      },
      {
        page: 'live-streaming-tech-diffs-screens',
        name: 'technical difficulties'
      },
      {
        page: 'live-streaming-linkedin-remastered-theme',
        name: 'linkedin remastered theme'
      },
      {
        page: 'live-streaming-starting-soon',
        name: 'starting soon screen'
      },
      {
        page: 'live-streaming-frame-overlay',
        name: 'frame overlay'
      },
      {
        page: 'live-streaming-key-takeaway',
        name: 'key takeaways'
      },
      {
        page: 'live-streaming-qa',
        name: 'Q&A screen'
      },{
        page: 'live-streaming-valentine-theme',
        name: 'valentines day theme'
      }
    ]
  },
  {
    page: 'ads-promo',
    name: 'ads promo',
    children: [
      { name: 'video ad Templates', page: 'ads-promo-ads' },
      { name: 'promo video Templates', page: 'ads-promo-promo' },
      { name: 'customer testimonial', page: 'ads-promo-testimonials' }
    ]
  },
  {
    page: 'trending',
    name: 'trending',
    children: []
  },
  {
    page: 'social-media',
    name: 'social media',
    children: [
      { name: 'youtube video templates', page: 'social-media-youtube' },
      { name: 'facebook video templates', page: 'social-media-facebook' },
      { name: 'instagram video templates', page: 'social-media-instagram' },
      { name: 'instagram stories templates', page: 'social-media-stories' },
      { name: 'youtube shorts templates', page: 'social-media-youtube-shorts' },
      { name: 'twitter stories templates', page: 'social-media-twitter' },
      { name: 'pinterest stories templates', page: 'social-media-pinterest' },
      { name: 'linkedIn stories templates', page: 'social-media-linkedin' },
      { name: 'trending hashtags', page: 'social-media-trending-hashtags' },
      { name: 'tikTok video templates', page: 'social-media-tiktok' }
    ]
  },
  {
    page: 'industry',
    name: 'industries',
    children: [
      { name: 'pets', page: 'industry-pets' },
      { name: 'wedding', page: 'industry-wedding' },
      { name: 'fashion', page: 'industry-fashion' },
      { name: 'business', page: 'industry-business' },
      { name: 'education', page: 'industry-education' },
      { name: 'lifestyle', page: 'industry-lifestyle' },
      { name: 'beauty & care', page: 'industry-beauty' },
      { name: 'video game', page: 'industry-video-game' },
      { name: 'real estate', page: 'industry-real-estate' },
      { name: 'travel & tourism', page: 'industry-travel' },
      { name: 'food & restaurants', page: 'industry-food' },
      { name: 'architecture', page: 'industry-architecture' },
      { name: 'health & pharma', page: 'industry-healthcare' },
      { name: 'nature & environment', page: 'industry-nature' },
      { name: 'music video templates', page: 'industry-music' },
      { name: 'entertainment', page: 'industry-entertainment' },
      { name: 'art & culture', page: 'industry-art-and-culture' },
      { name: 'E-commerce & retail', page: 'industry-e-commerce' },
      { name: 'technology & computers', page: 'industry-technology' },
      { name: 'recipe video templates', page: 'industry-food-recipe' },
      { name: 'marketing video templates', page: 'industry-marketing' },
      { name: 'fitness & wellness', page: 'industry-sports-and-fitness' },
      {
        name: 'Architecture & design',
        page: 'industry-architecture-and-design'
      }
    ]
  },
  {
    page: 'use-cases',
    name: 'use cases',
    children: [
      { name: 'memes', page: 'use-cases-memes' },
      { name: 'quotes', page: 'use-cases-quotes' },
      { name: 'stories', page: 'use-cases-stories' },
      { name: 'trending', page: 'use-cases-trending' },
      { name: 'Greetings', page: 'use-cases-greeting' },
      { name: 'countdown', page: 'use-cases-countdown' },
      { name: 'listicles', page: 'use-cases-listicles' },
      { name: 'slideshow', page: 'use-cases-slideshow' },
      { name: 'powerpoint', page: 'use-cases-powerpoint' },
      { name: 'travel vlog', page: 'use-cases-travel-vlog' },
      { name: 'intro & outro', page: 'use-cases-intro-outro' },
      { name: 'news video Templates', page: 'use-cases-news' },
      { name: 'product demo', page: 'use-cases-product-demo' },
      { name: 'frame video templates', page: 'use-cases-frame' },
      { name: 'lyric video Templates', page: 'use-cases-lyric' },
      { name: 'website videos', page: 'use-cases-website-video' },
      { name: 'recipe video templates', page: 'use-cases-recipe' },
      { name: 'special offers', page: 'use-cases-special-offers' },
      { name: 'blog promotion', page: 'use-cases-blog-promotion' },
      { name: "how to's & tutorials", page: 'use-cases-tutorials' },
      { name: 'collage video templates', page: 'use-cases-collage' },
      { name: 'event promotion', page: 'use-cases-event-promotion' },
      { name: 'presentation videos', page: 'use-cases-presentation' },
      { name: 'background video', page: 'use-cases-background-video' },
      { name: 'animated video templates', page: 'use-cases-animated' },
      { name: 'fun social posts', page: 'use-cases-fun-social-posts' },
      { name: 'lower third templates', page: 'use-cases-lower-third' },
      { name: 'podcast promotion', page: 'use-cases-podcast-promotion' },
      { name: 'presentation templates', page: 'use-cases-presentation' },
      { name: 'zoom virtual backgrounds', page: 'use-cases-zoom-backgrounds' },
      {
        name: 'restaurant promo video templates',
        page: 'use-cases-restaurant-promo'
      },
      { name: 'trailers', page: 'use-cases-trailers' },
    ]
  },
  {
    page: 'holidays',
    name: 'Holidays & Occasions',
    children: [
      { name: 'easter', page: 'holidays-easter' },
      { name: 'christmas', page: 'holidays-christmas' },
      { name: 'labor day', page: 'holidays-labor-day' },
      { name: 'halloween', page: 'holidays-halloween' },
      { name: 'holiday season', page: 'holiday-season' },
      { name: 'holiday season', page: 'holidays-season' },
      { name: 'happy birthday', page: 'holidays-birthday' },
      { name: 'Mother’s day', page: 'holidays-mothers-day' },
      { name: 'father’s day', page: 'holidays-fathers-day' },
      { name: 'observances', page: 'holidays-observances' },
      { name: 'thanksgiving', page: 'holidays-thanksgiving' },
      { name: 'memorial day', page: 'holidays-memorial-day' },
      { name: 'valentine’s day', page: 'holidays-valentines-day' },
      { name: 'back to school', page: 'holidays-back-to-school' },
      { name: 'independence day', page: 'holidays-independence-day' },
      {
        name: "st. patrick's day",
        page: 'holidays-st-patricks-day'
      },
      {
        name: 'black friday & cyber monday',
        page: 'holidays-black-friday-cyber-monday'
      }
    ]
  }
] as CategoryTreeItem[];

export default categoriesTree;
